import React, { useState, useEffect } from "react";
import { Fade } from "react-awesome-reveal";
import "../styles/Carousel.scss";
import Whats from "./Whats";
import img1 from "../images/carousel/1.png";
import img2 from "../images/carousel/2.png";
import img3 from "../images/carousel/3.png";
import img4 from "../images/carousel/4.png";
import img5 from "../images/carousel/5.png";

const Carousel = () => {
  const [anos, setAnos] = useState(0);
  const [reparaciones, setReparaciones] = useState(0);
  const [clientes, setClientes] = useState(0);

  let anosMax = 30;
  let reparacionesMax = 2000;
  let clientesMax = 600;

  useEffect(() => {
    const intervalId1 = setInterval(() => {
      if (anos < anosMax) {
        setAnos(anos + 1);
      } else {
        clearInterval(intervalId1);
      }
    }, 10);

    return () => clearInterval(intervalId1);
  }, [anos]);

  useEffect(() => {
    const intervalId2 = setInterval(() => {
      if (reparaciones < reparacionesMax) {
        setReparaciones(reparaciones + 10);
      } else {
        clearInterval(intervalId2);
      }
    }, 5);

    return () => clearInterval(intervalId2);
  }, [reparaciones]);

  useEffect(() => {
    const intervalId3 = setInterval(() => {
      if (clientes < clientesMax) {
        setClientes(clientes + 5);
      } else {
        clearInterval(intervalId3);
      }
    }, 10);

    return () => clearInterval(intervalId3);
  }, [clientes]);

  return (
    <div className="mb-5 carouselContainer" id="inicio">
      <div className="carouselText">
        <Fade>
        <h1 className="title1 mt-3">
          <b>Clases de inglés en San José del Cabo, rápidas, prácticas y garantizadas</b>
        </h1>
        </Fade>
        <h2 className="mb-3 title2">
           "Inglés presencial con atención personalizada y grupos reducidos"
        </h2>
        <span className="firstText">
        En High Life Language School te ayudamos a aprender inglés con un enfoque práctico en conversación y comprensión auditiva. Ofrecemos grupos reducidos, atención personalizada y un método con resultados comprobados en solo ocho meses. Mejora tus oportunidades laborales con el mejor costo-beneficio del mercado.
          <br />
        </span>
        <Fade>
          <div className="container containerDatosMain mt-4 mb-3">
            <div className="containerDatos">
              <span className="text-center contadorNum fw-bold" id="anosExp">
                {"+" + anos}
              </span>
              <br />
              <span className="contadorNumText fw-bold">
                Años de experiencia
              </span>
            </div>
            <div className="containerDatos">
              <span className="contadorNum fw-bold" id="reparaciones">
                {"+" + reparaciones}
              </span>
              <br />
              <span className="contadorNumText fw-bold">
                Estudiantes satisfechos
              </span>
            </div>
            <div className="containerDatos">
              <span className="contadorNum fw-bold" id="clientes">
                {"+" + clientes}
              </span>
              <br />
              <span className="contadorNumText fw-bold">
                Clases impartidas
              </span>
            </div>
          </div>
        </Fade>

        <Fade cascade="true" direction="left">
          <div className="mt-4 container containerBtn1">
            <Whats
              classStyle="col-sm-6 mb-2 fw-bold btn btnCarousel"
              phoneNumber="5216241270773"
              message="Hola, quiero más información acerca del curso de inglés."
              text="CONTÁCTANOS"
            />
          </div>
        </Fade>
      </div>

      <div className="carouselImages">
        <div
          id="carouselExampleAutoplaying"
          className="carousel slide"
          data-bs-ride="carousel"
        >
          <div className="carousel-inner imgBox">
            <div className="carousel-item active">
              <center>
                <img
                  src={img1}
                  className="d-block w-100 "
                  alt="Clases de inglés en vivo"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img2}
                  className="d-block w-100 "
                  alt="Metodo conversacional de inglés High Life Language School "
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img3}
                  className="d-block w-100 "
                  alt="Grupos de inglés reducidos"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img4}
                  className="d-block w-100 "
                  alt="Horarios de clases de inglés flexibles"
                />
              </center>
            </div>
            <div className="carousel-item">
              <center>
                <img
                  src={img5}
                  className="d-block w-100 "
                  alt="Extra Help de inglés semanal"
                />
              </center>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Carousel;
